
import m, { RequestOptions } from "mithril";
import { GlobalState } from "./globalstate";

export const serverUrl = (state: GlobalState, path: string): string => {
  return `${state.serverUrl}${path}`;
};

// Export a non-authenticated request for use by login.ts to avoid circular dependency
export const requestWithoutAuth = <T>(state: GlobalState, options: RequestOptions<T> & { url: string }) => {
  return m.request<T>({
    withCredentials: true,
    ...options,
    url: serverUrl(state, options.url),
  });
};
